module.exports = __webpack_public_path__ + "assets/img/1171587028283_.pic_hd.c3eea1b4.jpg";